/* @flow */

import * as React from 'react';

type RowElementProps = {
  label: string,
  value: any,
};

const AssetRequestDetails: React.StatelessFunctionalComponent<*> = (props: Object) => {
  const {
    t,
    assetRequestEnabled,
    assetRequestEmailAddress,
    rushAssetRequestEnabled,
    rushAssetRequestEmailAddress,
    tradingAccountPrefix,
  } = props;

  const RowElement = (rowProps: RowElementProps) => {
    const { label, value } = rowProps;
    return (
      <tr>
        <td>
          <b>{t(`general:assets.labels.${label}`)}:</b>
        </td>
        <td>{value}</td>
      </tr>
    );
  };

  const hasRushOrAssetEnabled: boolean = assetRequestEnabled || rushAssetRequestEnabled;
  if (!hasRushOrAssetEnabled) return <></>;
  return (
    <table>
      <tbody>
        {assetRequestEnabled && (
          <RowElement label="asset_request_form_email" value={assetRequestEmailAddress} />
        )}
        {rushAssetRequestEnabled && (
          <RowElement label="rush_asset_request_form_email" value={rushAssetRequestEmailAddress} />
        )}
        <RowElement label="asset_request_account_prefix" value={tradingAccountPrefix} />
      </tbody>
    </table>
  );
};

export default AssetRequestDetails;
